/**
 * Use to narrow anything into a boolean. Especially useful in arr.filter(typedBoolean),
 * as the type of the resulting array elements will be inferred to T, in contrast
 * to arr.filter(Boolean), which does not yield the same result.
 *
 * @param value
 */
export function typedBoolean<T>(
  value: T,
): value is Exclude<T, "" | 0 | false | null | undefined> {
  return Boolean(value);
}
